import React from 'react';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileActionButtonProps } from './types';
import styles from '../index.module.scss';

export const MediafileActionButton: React.FC<MediafileActionButtonProps> = ({ id, action }) => (
  <div className={styles.actionCell}>
    <IconButton
      elementId={DATA_TEST_IDS.ACTION(id, action.id)}
      className={styles.action}
      isDisabled={action.isDisabled}
      aria-label={action.label}
      hint={action.label}
      aria-pressed={action.kind === 'toggle' ? action.isPressed : undefined}
      onClick={() => {
        if (!action.isDisabled) action.onClick();
      }}>
      <span aria-hidden="true">{action.icon}</span>
    </IconButton>
  </div>
);
